<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Form-->
<div class="Main2Col">
	<!--Code-->
	<label>Code:</label>
	<input [(ngModel)]="Code" placeholder="Enter Code/Acronym" class="form-control" type="text" />

	<!--Desc-->
	<label>Name:</label>
	<input [(ngModel)]="Name" placeholder="Enter Name/Description" class="form-control" type="text" />
</div>

<!--Buttons-->
<div class="Center TopMargin">
	<button class="btn btn-primary" (click)="onUpdate()">Add</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
